import { DEFAULT_LABELS, fillLabels, lineSpecOnScreen, type Labels } from "@genbaryoku/contract";
import { useMe } from "./auth.js";
import { tp } from "./lib/product.js";

/**
 * 言葉の切替（027、docs/22）。「顧客」「工事名」など、会社ごとに違う言葉はここから引く。
 *   - 画面の JSX では useLabels() → L.customer
 *   - 決まり文（PARTNER_MSG など）の {customer} は t() で置き換える（messageOf も通す）
 * Me（/me）に乗って来るので、ログイン後の画面ならいつでも使える。読む前は工務店向けの既定
 */
let current: Labels = DEFAULT_LABELS;

/** Shell（ログイン後の枠）が描くたびに呼ぶ。同じ値なら何もしない */
export function setCurrentLabels(l: Labels | undefined): void {
  if (l) current = l;
}

export function currentLabels(): Labels {
  return current;
}

/** 決まり文の {customer} {subject} … をいまの会社の言葉に、{product} {productHost} をいまの製品に（049） */
export function t(text: string): string {
  return tp(fillLabels(text, current));
}

/** 見積の入力の表の規格の列の見出し（#222。既定の「規格」なら「規格・仕様」のまま） */
export function lineSpecLabel(): string {
  return lineSpecOnScreen(current);
}

export function useLabels(): Labels {
  const me = useMe();
  const l = me.data?.tenant.labels ?? DEFAULT_LABELS;
  current = l;
  return l;
}
